import Vue from "vue";

Vue.mixin({

    methods: {
        _validarCamposObrigatoriosLicitacaoAtualizacao(licitacao) {

            const camposNaoPreenchidos = []

            if (!licitacao) {
                console.error('Os campos da licitação não foram informados.')
                return camposNaoPreenchidos
            }

            const camposObrigatorios = [
                { valor: licitacao.modalidade, mensagem: 'Informe a modalidade.' },
                { valor: licitacao.idAmparoLegal, mensagem: 'Informe o amparo legal.' },
                { valor: licitacao.tipoLicitacao, mensagem: 'Informe o tipo de licitação.' },
                { valor: licitacao.numProcesso, mensagem: 'Informe o número de processo.' },
                { valor: licitacao.idOrgao, mensagem: 'Informe o responsável.' },
                { valor: licitacao.tipoDisputa, mensagem: 'Informe o tipo de disputa.' },
                { valor: licitacao.idComissaoApuracao, mensagem: 'Informe a comissão.' },
                { valor: licitacao.idResponsavel, mensagem: 'Informe o agente responsável.' },
                { valor: licitacao.dataIniEnvioProposta, mensagem: 'Informe a data/hora de início de envio de propostas.' },
                { valor: licitacao.dataFimEnvioProposta, mensagem: 'Informe a data/hora do fim de envio de propostas.' },
                { valor: licitacao.dataAbertura, mensagem: 'Informe a data/hora de abertura.' },
                { valor: licitacao.categoria, mensagem: 'Informe a categoria.' },
                { valor: licitacao.modoDisputa, mensagem: 'Informe o modo de disputa.' },
                { valor: licitacao.objeto, mensagem: 'Informe o objeto.' }
            ]

            if (this._ehObrigatorioInformarIDContratacaoPNCP(licitacao)) {
                camposObrigatorios.push({
                    valor: licitacao.idContratacaoPncp,
                    mensagem: 'Informe o Id de contratação do PNCP.'
                })
            }
            if(this._ehIntegracaoPrestacaoContasAtiva()){
                camposObrigatorios.push({
                    valor: licitacao.dataPrevisaoPublicacao,
                    mensagem: 'Informe a data de previsão da publicação.'
                })
            }

            const modosQueExigemDiferencaMinima = ['ABERTO', 'ABERTO_FECHADO', 'FECHADO_ABERTO'];

            if (modosQueExigemDiferencaMinima.includes(licitacao.modoDisputa)) {
                camposObrigatorios.push({
                    valor: licitacao.diferencaMinimaLance,
                    mensagem: 'Informe a diferença mínima entre lances.'
                });
            }

            camposObrigatorios.forEach(campo => {
                if (!campo.valor) {
                    camposNaoPreenchidos.push({ mensagem: campo.mensagem })
                }
            })

            return camposNaoPreenchidos
        },

        _ehObrigatorioInformarIDContratacaoPNCP(licitacao){
            const propriedadesLicitacao = this.$store.state.parametros.propriedadesLicitacao
            if (!propriedadesLicitacao.permitirInformarIdContratacaoPncp) {
                return false
            }

            const modalidadesExcecao = propriedadesLicitacao.permitirInformarIdContratacaoPncpExcetoModalidades
            const modalidade = licitacao && licitacao.modalidade

            if (!modalidadesExcecao || !modalidade) {
                return true
            }

            return !modalidadesExcecao
                .split(',')
                .map(item => item.trim())
                .filter(item => item)
                .some(item => item === modalidade)
        },

        _ehIntegracaoPrestacaoContasAtiva() {
            return this.$store.state.parametros.propriedadesLicitacao.integration.integracaoSistemaDePrestacaoContasAtiva
        }
    }
})